export type ReturnParams = {
    returnKey: string;
    returnItemId?: string;
    email: string;
    dealId: string;
    quoteId?: string;
};

export const portalUrl = import.meta.env.VITE_PORTAL_URL;

const redirectPaths: Record<string, (params: ReturnParams) => string | null> = {
    measurement: ({ email, dealId, quoteId }) =>
        quoteId
            ? `${portalUrl}/redirect?email=${email}&dealId=${dealId}&quoteId=${quoteId}&key=measurement`
            : null,
    measurementItem: ({ returnItemId, email, dealId, quoteId }) =>
        returnItemId && quoteId
            ? `${portalUrl}/redirect?email=${email}&dealId=${dealId}&quoteId=${quoteId}&key=measurementItem&itemId=${returnItemId}`
            : null,
};

export const getInformationReturnPath = (
    params: ReturnParams,
): string | null => {
    const redirectFn = redirectPaths[params.returnKey];
    return redirectFn ? redirectFn(params) : null;
};
